import React, { FC, Fragment, SyntheticEvent, useState } from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { LinkItem, MenuItems } from "./HeaderMenuLinks";
import { COLORS } from "../../theme";

export const HeaderMenu: FC<{ title: string; menuItems?: MenuItems }> = ({ title, menuItems }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = !!anchorEl;

    const openMenu = (event: SyntheticEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (link: LinkItem) => {
        setAnchorEl(null);
        window.open(link.href, "_blank");
    };

    return (
        <Fragment>
            <Button
                onClick={openMenu}
                variant={"text"}
                role="menubutton"
                sx={{
                    mx: 3,
                    justifyContent: "left",
                    color: COLORS.SB_GREY,
                }}
                disableElevation
            >
                <Box sx={{ width: "100%" }}>{title}</Box>
                <KeyboardArrowDown />
            </Button>
            <Menu anchorEl={anchorEl} keepMounted open={open} onClose={handleClose} disableScrollLock={true}>
                {menuItems?.map((linkItem) => (
                    <MenuItem onClick={() => handleItemClick(linkItem)} key={linkItem.label}>
                        {linkItem.label}
                    </MenuItem>
                ))}
            </Menu>
        </Fragment>
    );
};
